import HeaderRound from '@shared/assets/images/header_round.svg?react';

import styles from './RoundWaveContentHeader.module.css';

const RoundWaveContentHeader = () => {
  return <HeaderRound className={`${styles.headerRound} ion-hide-xl-up`} />;
};

export default RoundWaveContentHeader;
